import React, {useEffect} from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField} from "@material-ui/core";
import {useFormik} from "formik";
import Grid from "@material-ui/core/Grid";
import {DropzoneAreaBase} from "material-ui-dropzone";
import makeStyles from "@material-ui/core/styles/makeStyles.js";

const useStyles = makeStyles(() => (
    {
        previewChip: {
            minWidth: 160,
            maxWidth: 210
        }
    }
))

const EditDocumentDialog = (props) => {
    const {open, onClose, submitCallback, onDownloadFile, initialValues} = props

    const classes = useStyles()

    const onSubmit = async (values) => {
        await submitCallback(values)
    }

    const {getFieldProps, resetForm, submitForm, setValues, setFieldValue} = useFormik({
        initialValues: {
            id: undefined,
            name: '',
            file: undefined
        },
        onSubmit: onSubmit
    })

    const handleCloseDialog = () => {
        onClose()
        resetForm()
    }

    const handleSubmitButtonClick = async () => {
        await submitForm()
        handleCloseDialog()
    }

    const handleDownloadFile = async () => {
        await onDownloadFile(getFieldProps('id').value)
    }

    const handleAddFile = async (newFiles) => {
        await setFieldValue('file', ...newFiles)
    }

    const handleDeleteFile = async () => {
        await setFieldValue('file', undefined)
    }

    const getFilesArray = (file) => {
        if (typeof file === 'object' && file !== null) return [file]
        if (typeof file === 'string') return [{file: {name: file.split('/')[1]}}]
        return []
    }

    useEffect(() => {
        if (open && initialValues) {
            setValues(initialValues)
        }
    }, [open, initialValues])

    return (
        <Dialog open={open} onClose={handleCloseDialog} maxWidth={"sm"} fullWidth>
            <DialogTitle>Редактировать документ</DialogTitle>
            <DialogContent>
                <Grid container direction={'column'} spacing={1}>
                    <Grid item>
                        <TextField
                            label={'Название документа'}
                            fullWidth
                            multiline
                            name={'name'}
                            {...getFieldProps('name')}
                        />
                    </Grid>
                    <Grid item container alignItems={'center'}>
                        <DropzoneAreaBase
                            acceptedFiles={[
                                'application/pdf',
                                'application/rtf',
                                'application/msword',
                                'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                            ]}
                            fileObjects={getFilesArray(getFieldProps('file').value)}
                            maxFileSize={10000000}
                            filesLimit={1}
                            onAdd={handleAddFile}
                            onDelete={handleDeleteFile}
                            dropzoneText={'Нажмите на выделенную область или перетащите файлы для загрузки'}
                            getFileLimitExceedMessage={(filesLimit) => `Превышено максимально допустимое количество файлов. Разрешено только ${filesLimit} `}
                            getFileAddedMessage={(fileName) => `Файл ${fileName} успешно добавлен `}
                            getFileRemovedMessage={(fileName) => `Файл ${fileName} удален `}
                            getDropRejectMessage={(rejectedFile) => `Файл ${rejectedFile.name} был отклонен `}
                            showPreviews={true}
                            showPreviewsInDropzone={false}
                            useChipsForPreview
                            previewGridProps={{container: {spacing: 1, direction: 'row'}}}
                            previewChipProps={
                                {
                                    classes: {
                                        root: classes.previewChip,
                                    },
                                    onClick: handleDownloadFile,
                                }}
                            previewText="Загруженные файлы"
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseDialog}>
                    Отмена
                </Button>
                <Button onClick={handleSubmitButtonClick}>
                    Сохранить
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default EditDocumentDialog;